import { css } from '@emotion/core'

export default {
    padding: css({
        paddingInline: [0, null, "4rem"],
    })
}